export type TransactionType = 'sale' | 'lease' | 'consulting' | 'consultation' | 'expense' | 'capital_advisors' | 'rating' | 'resi' | 'dsf' | 'valuation' | 'disbursement';

export const TransactionTypes = {
  SALE: <TransactionType>'sale',
  LEASE: <TransactionType>'lease',
  CONSULTING: <TransactionType>'consulting',
  CONSULTATION: <TransactionType>'consultation',
  EXPENSE: <TransactionType>'expense',
  CAPITAL_ADVISORS: <TransactionType>'capital_advisors',
  RATING: <TransactionType>'rating',
  RESI: <TransactionType>'resi',
  DSF: <TransactionType>'dsf',
  VALUATION: <TransactionType>'valuation',
  DISBURSEMENT: <TransactionType>'disbursement',
};

export const TransactionTypesPermalink = {
  [TransactionTypes.SALE]: 'sales',
  [TransactionTypes.LEASE]: 'leases',
  [TransactionTypes.CONSULTING]: 'consulting',
  [TransactionTypes.CONSULTATION]: 'consultations',
  [TransactionTypes.EXPENSE]: 'expenses',
  [TransactionTypes.DISBURSEMENT]: 'disbursement',
  [TransactionTypes.CAPITAL_ADVISORS]: 'capital_advisors',
  [TransactionTypes.RATING]: 'rating',
  [TransactionTypes.VALUATION]: 'valuations',
  [TransactionTypes.DSF]: 'dsfs',
  [TransactionTypes.RESI]: 'resi',
};

export const TransactionStatus = {
  APPROVED: 'Approved',
  PENDING_APPROVAL: 'Pending Approval',
  INVOICED: 'Invoiced',
  IN_PROGRESS: 'In Progress',
  WIP: 'Work in Progress',
  CREDIT_PENDING_BUSINESS_APPROVAL: 'Credit Pending Business Approval',
  ADJUST_BILL_LINES: 'Adjust Bill Lines',
  DENIED: 'Denied',
  REBILL: 'Rebill',
  ERROR: 'Error',
};

export const TransactionStatusFilters = {
  WIP: 'wip',
  SUBMITTED: 'submitted',
  CLOSED: 'closed', 
};

export type RepresentativeType = 'tenant' | 'landlord' | 'buyer' | 'seller' | 'borrower' | 'lender' | 'client';

export const RepresentativeTypes = {
  TENANT: <RepresentativeType>'tenant',
  LANDLORD: <RepresentativeType>'landlord',
  BUYER: <RepresentativeType>'buyer',
  SELLER: <RepresentativeType>'seller',
  BORROWER: <RepresentativeType>'borrower',
  LENDER: <RepresentativeType>'lender',
  CLIENT: <RepresentativeType>'client'
};

export type UpdateInvoiceActionsType = 'CREDIT_INVOICE' | 'CREDIT_REBILL_INVOICE' | 'ADJUST_BILL_LINES' | 'COPY_TRANSACTION';

export const UpdateInvoiceActions = {
  CREDIT_INVOICE: <UpdateInvoiceActionsType>'CREDIT_INVOICE',
  CREDIT_REBILL_INVOICE: <UpdateInvoiceActionsType>'CREDIT_REBILL_INVOICE',
  ADJUST_BILL_LINES: <UpdateInvoiceActionsType>'ADJUST_BILL_LINES',
  COPY_TRANSACTION: <UpdateInvoiceActionsType>'COPY_TRANSACTION',
};

